module.exports = __webpack_public_path__ + "static/Tpv-main-ba2cbb5f84e80ed0c920de1aed303139.jpg";